<template>
  <div
    :class="template.secondaryTheme ? 'custom-glass-card' : 'text-white rounded glass-card'"
    :style="template.secondaryTheme ? { background: hexToRgba(template.primaryColor, 0.75) } : {}"
  >
    <!-- Logo -->
    <div class="col-sm-12 mt-4 pt-2 d-flex justify-content-center align-items-center">
      <img
        class="img-fluid rounded"
        :src="template.logoUrl"
        style="overflow: hidden; margin-bottom: 25px"
        :width="cardLogoWidth"
      />
    </div>
    <div class="d-flex justify-content-center">
      <img :src="template.logoSecondaryUrl" style="overflow: hidden" width="84px" />
    </div>
    <slot></slot>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'GlassCard',
  computed: {
    ...mapGetters(['cardLogoWidth']),
    ...mapState(['template', 'sso']),
  },
  methods: {
    hexToRgba(hex, alpha) {
      const r = parseInt(hex.slice(1, 3), 16)
      const g = parseInt(hex.slice(3, 5), 16)
      const b = parseInt(hex.slice(5, 7), 16)

      return `rgba(${r}, ${g}, ${b}, ${alpha})`
    },
  },
}
</script>

<style scoped>
.glass-card {
  min-width: 360px;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(2.5px);
  -webkit-backdrop-filter: blur(2.5px);
}

.custom-glass-card {
  min-width: 360px;
  backdrop-filter: blur(2.5px);
  -webkit-backdrop-filter: blur(2.5px);
}
</style>
